var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button-full",
    {
      attrs: {
        categoryProps: _vm.categoryProps,
        round: true,
        "active-color": true,
        disabled: _vm.isProductDisabled,
        "data-testid": "addToCart"
      },
      nativeOn: {
        click: function($event) {
          return _vm.addToCart(_vm.product)
        }
      }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.$t("Add to cart")) + "\n  "),
      _c("i", { staticClass: "material-icons ml10" }, [_vm._v("shopping_cart")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }